import api from '@/api'
export default {
  namespaced: true,
  state: {
    platform: [],
    allMctype: [],
  },
  mutations: {
    setPlatform(state, data) {
      state.platform = data;
    },
    setMctype(state, data) {
      state.allMctype = data;
    }
  },
  actions: {
    async getPlatform({ commit }) {
      // // 获取平台信息
      let { code, data } = await api.advancedService.getAllPlatform();
      if (code == 10000) {
        commit('setPlatform', data);
      }
    },
    async getAllMctype({ commit }) {
      let { code, data } = await api.advancedService.getAllMctype();
      if (code == 10000) {
        commit('setMctype', data);
      }
    },
    
  }
};
